import { type ListItem } from '@capsicum/features/wallet/shared';
import { type PartnerWithImageMap } from '@capsicum/socios-core';
import { createContext } from 'react';

export interface TransactionCardsContextValue {
	dataForList: Array<ListItem>;
	getPartnerByShortName: (shortName: string | undefined) => PartnerWithImageMap | undefined;
}

export const TransactionCardsContext = createContext<TransactionCardsContextValue>({
	dataForList: [],
	getPartnerByShortName: () => undefined
});
